export default __webpack_public_path__ + "static/media/undraw09.ae872d44.svg";